import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "export-complete" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("video", {
  autoplay: "",
  muted: "",
  loop: ""
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: "https://static.serato.com/visualizer/videos/swirly-purple-forms-compressed.mp4",
    type: "video/mp4"
  })
], -1)
const _hoisted_3 = { class: "export-complete__foreground" }
const _hoisted_4 = { class: "export-complete__middle-container" }
const _hoisted_5 = { class: "export-complete__middle-section" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, "Boom. Your video is ready to download", -1)
const _hoisted_7 = { class: "export-complete__body-text" }
const _hoisted_8 = ["href", "download"]
const _hoisted_9 = { class: "export-complete__buttons" }

import BigButton from '@/components/common/BigButton.vue'
import useAudioEngine from '@/composables/UseAudioEngine'
import { useProjectStore } from '@/store/project-store'
import { useApplicationStore } from '@/store/application-store'
import { useExportStore } from '@/store/export-store'
import { useStickerGalleryStore } from '@/store/gallery/sticker-store'
import { useBackgroundGalleryStore } from '@/store/gallery/background-store'
import useEffect from '@/composables/UseEffect'
import useLayers from '@/composables/UseLayers'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportComplete',
  emits: ["closeOverlay"],
  setup(__props, { emit: emits }: { emit: ({
  (event: 'closeOverlay'): void
}), expose: any, slots: any, attrs: any }) {


const projectStore = useProjectStore()
const applicationStore = useApplicationStore()
const backgroundStore = useBackgroundGalleryStore()
const stickerStore = useStickerGalleryStore()
const exportStore = useExportStore()

const { unloadAudio } = useAudioEngine()
const { removeAllEffects } = useEffect()
const { resetLayers } = useLayers()


const resetProject = () => {
  unloadAudio()
  removeAllEffects()
  resetLayers()
  backgroundStore.reset()
  stickerStore.$reset()
  applicationStore.$reset()
  projectStore.$reset()
  emits('closeOverlay')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, [
            _createTextVNode("Video not downloading automatically? "),
            _createElementVNode("a", {
              href: _unref(exportStore).downloadLink,
              download: _unref(exportStore).fileName
            }, "Download manually", 8, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(BigButton, {
              text: "Continue editing",
              "is-disabled": false,
              "is-loading": false,
              type: "secondary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('closeOverlay')))
            }),
            _createVNode(BigButton, {
              text: "Make a new video",
              "is-disabled": false,
              "is-loading": false,
              type: "secondary",
              onClick: resetProject
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})